export default __webpack_public_path__ + "static/media/lt.07f36a8b.svg";